import {NotificationEvent} from './notification-event.model';

export class NotificationArea {
    ID: number;
    Name: string;
    Description: string;
    ValidForStaff: boolean;
    ValidForStudents: boolean;
    ValidForParents: boolean;
    NotificationEvents: NotificationEvent[] = [];
}
